import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppState } from 'context/AppState';
import { getTrialLocation } from 'utils/trialLocationData';
import { getCropName } from '../HeroBanner/heroBannerUtils';

interface ReportOverviewData {
  recommendationCW: any;
  countryRegion: string | undefined;
  region: string | undefined;
  reportOverviewDescription: string;
  cropName: string;
}

export const useReportOverviewData = (): ReportOverviewData => {
  const [t] = useTranslation();
  const {
    apiData: { recommendationCropwise, countryList },
  } = useAppState();

  return useMemo(() => {
    const cw = recommendationCropwise?.recommendations[0];
    const cr =
      recommendationCropwise?.country === 'Brazil'
        ? 'Brasil'
        : cw?.multi_field?.config?.agronomicInputs?.extraInfo?.countryRegion;

    const generatedBy = cw?.multi_field?.config?.agronomicInputs?.generatedby;
    const isScriptGenerated = generatedBy === 'script';
    const reg = cr || countryList?.[0]?.region;

    const description = isScriptGenerated
      ? t(`The Expert Seed Advice description Script ${reg}`)
      : t(`The Expert Seed Advice description ${reg}`, {
        num: getTrialLocation(cw?.crop_name ?? '', reg ?? ''),
      });

    return {
      recommendationCW: cw,
      countryRegion: cr,
      region: reg,
      reportOverviewDescription: description,
      cropName: cw?.crop_name ?? '',
    };
  }, [recommendationCropwise, countryList, t]);
};
